import { render, staticRenderFns } from "./ComplementaryExams.vue?vue&type=template&id=77e776d8&scoped=true"
import script from "./ComplementaryExams.vue?vue&type=script&lang=js"
export * from "./ComplementaryExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e776d8",
  null
  
)

export default component.exports